"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontThemeClasses = exports.getFontThemeClassNames = exports.getParsedFontDeclarations = void 0;
var tslib_1 = require("tslib");
var fonts_1 = tslib_1.__importDefault(require("@wix/santa-core-utils/dist/fonts"));
var consts_1 = require("../consts");
var parseStyleFont = fonts_1.default.parseStyleFont;
var PARSED_FONT_KEY_TO_CSS_PROP_MAP = {
    fontWithFallbacks: 'font-family',
    size: 'font-size',
    weight: 'font-weight',
    style: 'font-style'
};
var generatePropertyKey = function (typeName, index) { return "".concat(typeName, "_").concat(index); };
var getPropertiesAccordingToType = function (typeName, values) {
    return values ? values.reduce(function (result, value, index) {
        result[generatePropertyKey(typeName, index)] = value;
        return result;
    }, {}) : {};
};
function getParsedFontDeclarations(parsedFont) {
    var parsedFontKeys = Object.keys(PARSED_FONT_KEY_TO_CSS_PROP_MAP);
    return parsedFontKeys.reduce(function (declarations, parsedFontKey) {
        var currentCSSProp = PARSED_FONT_KEY_TO_CSS_PROP_MAP[parsedFontKey];
        if (currentCSSProp && parsedFont[parsedFontKey] !== undefined) {
            declarations[currentCSSProp] = parsedFont[parsedFontKey];
        }
        return declarations;
    }, {});
}
exports.getParsedFontDeclarations = getParsedFontDeclarations;
function getFontThemeClassNames(themeData) {
    return Object.keys(getPropertiesAccordingToType(consts_1.THEME_FONT_KEY, themeData[consts_1.THEME_FONT_KEY])).map(function (fontStyleName) { return ".".concat(fontStyleName); });
}
exports.getFontThemeClassNames = getFontThemeClassNames;
function getFontThemeClasses(themeData) {
    var themeFonts = getPropertiesAccordingToType(consts_1.THEME_FONT_KEY, themeData[consts_1.THEME_FONT_KEY]);
    var themeColors = getPropertiesAccordingToType(consts_1.THEME_COLOR_KEY, themeData[consts_1.THEME_COLOR_KEY]);
    return Object.keys(themeFonts)
        .reduce(function (fontThemeClasses, fontStyleName) {
        fontThemeClasses[fontStyleName] = getParsedFontDeclarations(parseStyleFont(fontStyleName, themeFonts, themeColors));
        return fontThemeClasses;
    }, {});
}
exports.getFontThemeClasses = getFontThemeClasses;
//# sourceMappingURL=font-utils.js.map